<template>
  <el-popover placement="left" width="690" trigger="click" popper-class="more_popover" v-model="visible">
    <div>
      <div class="more_popover_top">
        <el-row class="mb-10">
          <el-col :span="12">
            <el-autocomplete popper-class="my-autocomplete" v-model="state" value-key="label" :fetch-suggestions="querySearch" placeholder="请输入内容" size="mini" @select="searchHandle">
              <el-button slot="append" size="mini" icon="el-icon-search">查询</el-button>
              <template slot-scope="{ item }">
                <div class="name" v-html="setSelectText(item)"></div>
              </template>
            </el-autocomplete>
          </el-col>
          <el-col :span="12">
            <span :class="{'is-select1': !selectedList.length}" @click="clearAll">全国</span>
            <span v-for="(item,i) in fastList" :key="i" :class="{'is-select1': item.selected}" @click="clickSelect(item)">{{item.label}}</span>
          </el-col>
        </el-row>
        <div class="more_popover_content" :style="{height:isArea?'414px':'370px'}">
          <div class="area-select" v-if="isArea">
            <span>省份首字母：</span>
            <span v-for="item in list" :key="item" class="area-select-index" @click="wordLocation(item)">{{item}}</span>
          </div>
          <div class="hierarchy" ref="menus">

            <div class="hierarchy1" id="hierarchy-box" :style="menus[1]&&menus[1].length? 'flex: 0 1 0%;': 'flex: 1 1 0%;'">
              <div class="hierarchy-name" v-for="(item,i) in nodes" :key="i" :id="item.head" :class="{'is-select': item.selected}" @click="clickSelect(item)">
                <span :id="item.data.head">{{item.data.head}}</span>
                <div>{{item.label}}</div>
              </div>
            </div>

            <SubPanel v-if="menus[1]&&menus[1].length" :data="menus[1]" :activePath="activePath" :level="1" class="hierarchy1"
             style="border-left: 1px solid #f2f3f5;"
              :style="menus[2]&&menus[2].length? 'flex: 0 1 0%;': 'flex: 1 1 0%;'"
              @selected="clickSelect" @selectedAll="clearSub" />

            <SubPanel v-if="menus[2]&&menus[2].length" :data="menus[2]" :activePath="activePath" :level="2" class="hierarchy3" style="border-left: 1px solid #f2f3f5;" @selected="clickSelect"
              @selectedAll="clearSub" />
          </div>
        </div>
        <div class="div-selected">
          <p>已选（<span>{{selectedList.length}}</span>/{{maxSelected}}）<span style="cursor: pointer;" class="ml-10" @click="clearAll">清空</span></p>
          <div>
            <span v-for="(item,i) in selectedList" :key="i" @click="deleteTag(i)">
              {{item.parent? item.parent.label+'-'+ item.label:item.label}}
              <i class="el-icon-close"></i></span>
          </div>
        </div>
      </div>
      <div class="more_popover_bottom">
        <el-button size="small" type="text" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" @click="submitHandle">确定</el-button>
      </div>
    </div>
    <span slot="reference" :class="['showMore',{'is-opened':visible}]">{{popoverText}}
      <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
    </span>
  </el-popover>
</template>

<script>
import SubPanel from '@/components/multiLvSelect/subPanel'
import Node from '@/utils/node'
import { flattenTree } from '@/utils/util'
import multiLvSelect from '@/components/multiLvSelect/multiLvSelect.js'

const DefaultProps = {
  expandTrigger: 'click', // or hover
  multiple: false,
  checkStrictly: false, // whether all nodes can be selected
  emitPath: true, // wether to emit an array of all levels value in which node is located
  lazy: false,
  lazyLoad: () => { },
  value: 'value',
  label: 'label',
  children: 'childOption',
  leaf: 'leaf',
  disabled: 'disabled',
  hoverThreshold: 500
}

export default {
  name: 'MultiLvSelectArea',
  extends: multiLvSelect,
  components: {
    SubPanel,
  },
  props: {
    isArea: {
      type: Boolean,
      default: true
    },
    popoverText: {
      type: String,
      default: '更多'
    },
    data: {
      type: Array,
      default: () => []
    },
    echoList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      visible: false,
      input: '',
      list: ['A', 'B', 'C', 'F', 'G', 'H', 'J', 'L', 'N', 'Q', 'S', 'T', 'X', 'Y', 'Z'],
      fastLabel: ['北京市', '上海市', '天津市', '重庆市', '广东省'],
      fastList: [],
      selectedList: [],
      menus: [],
      activePath: [],
      nodes: null,

      restaurants: [],
      state: ''
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!val) return
        val = this.$lodash.cloneDeep(val)
        // 添加必要字段
        this.nodes = val.map(nodeData => new Node(nodeData, DefaultProps))
        // 设置菜单
        this.menus = [this.nodes]
        // 设置快捷
        this.nodes.forEach(node => {
          if (this.fastLabel.includes(node.data.label)) {
            this.fastList.push(node)
          }
        })
        // 展开搜索映射
        this.restaurants = flattenTree(this.nodes)
        this.echoListReady && this.FastSetDataAwait()
      }
    }
  },
  methods: {
    wordLocation(item) {
      document.getElementById('hierarchy-box').scrollTop = document.getElementById(item).offsetTop - 121
    }
  }

}
</script>
<style lang="scss" scoped>
.more_popover {
  font-size: 12px;
  padding: 0;
  .more_popover_top {
    .div-selected {
      p {
        font-weight: 500;
        font-size: 12px;
        color: #000;
        height: 40px;
        line-height: 40px;
        span {
          color: #4f7afd;
        }
      }
      div {
        width: 100%;
        height: 73px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        span {
          display: inline-block;
          padding: 0 26px 0 8px;
          background: #f5f8ff;
          border-radius: 2px;
          font-size: 12px;
          color: #333;
          height: 22px;
          line-height: 22px;
          margin: 0 8px 8px 0;
          position: relative;
          cursor: pointer;
          &:hover {
            i {
              color: #4f7afd;
            }
          }
          i {
            position: absolute;
            right: 5px;
            top: 5px;
            font-size: 12px;
            color: #b2b7c2;
          }
        }
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #bbbeca;
        }
      }
    }
    .more_popover_content {
      height: 414px;
      border: 1px solid #eee;
      border-radius: 8px;
      .hierarchy {
        display: flex;
        height: 368px;
      }
      ::v-deep .hierarchy3 {
        padding-top: 12px;
        padding-left: 28px;
        margin-right: -10px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        > div {
          line-height: 36px;
          margin-right: 30px;
          cursor: pointer;
          &:hover {
            color: #4f7afd !important;
          }
        }
      }
      ::v-deep .hierarchy1 {
        overflow-y: auto;
        min-width: 129px;
        padding-top: 12px;
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #bbbeca;
        }
        .hierarchy-name {
          &:hover {
            background: #ebf0fe;
          }
          // width: 100%;
          min-height: 36px;
          padding: 9px 8px 9px 14px;
          line-height: 18px;
          cursor: pointer;
          display: flex;
          span {
            display: inline-block;
            width: 18px;
            font-size: 14px;
            font-weight: 500;
          }
          &.is-select {
            color: #4f7afd;
            font-weight: 500;
            background: #ebf0fe;
          }
        }
      }

      ::v-deep .is-select {
        color: #4f7afd;
        font-weight: 500;
      }
      .area-select {
        background: #f9f9f9;
        border-radius: 8px 8px 0 0;
        padding: 12px 0 11px 16px;
        user-select: none;
        .area-select-index {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.65);
          display: inline-block;
          background: #fff;
          border-radius: 4px;
          width: 21px;
          height: 21px;
          line-height: 21px;
          text-align: center;
          margin-right: 14px;
          cursor: pointer;
        }
      }
    }
    .el-row {
      height: 32px;
      line-height: 32px;
      .el-col-12 + .el-col-12 {
        text-align: right;
        span {
          cursor: pointer;
        }
        span + span {
          margin-left: 15px;
        }
      }
      .el-button {
        color: #fff;
        background: #4f7afd;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  .more_popover_bottom {
    border-top: 1px solid #ededed;
    padding: 22px 32px;
    padding-top: 17px;
    text-align: right;
  }
}

.is-select1 {
  color: #4f7afd;
}

.showMore {
  cursor: pointer;
  font-size: 13px;
  color: rgba(51, 51, 51, 0.5);
  float: right;
  position: relative;
  width: 42px;
  i {
    color: rgba(52, 57, 81, 0.5);
    right: 0;
  }

  &.is-opened .el-submenu__icon-arrow {
    transform: rotate(180deg);
  }
}
</style>
